import React from 'react'
export default function Footer(props) {
    const colorPick=(event)=>{
        const colorselected=event.target.value;
        document.body.style.backgroundColor=colorselected;
    }
  return (
    <>
      <div className="footerhead">
        <div className="sameclass" style={{color:props.mode==="dark"?'white':'black',backgroundColor:props.mode==="dark"?'#030e12':'white'}}>
         <label htmlFor="colorpick" style={{color:props.mode==="dark"?'white':'black',backgroundColor:props.mode==="dark"?'#030e12':'white'}}>Color picker</label>
         <input type="color" id="colorpicker1" onChange={colorPick} value="#FFBD33"/>
         </div>
         </div>
       </>
  )
}
